import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import logo from "../JamTogether.png";

import { HashLink } from "react-router-hash-link";

const settings = ["Profile", "Settings", "Logout"];

function NavBar() {
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar position="sticky" color="primary">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", gap: 50, alignItems: "center" }}>
              <HashLink to="/" style={{ textDecoration: "none" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <Typography
                    variant="h6"
                    style={{ color: "#a254cc", fontWeight: "bold" }}
                  >
                    JAM
                  </Typography>
                  <img
                    src={logo}
                    style={{ height: 50, width: 50 }}
                    className="App-logo"
                    alt="logo"
                  />
                  <Typography
                    variant="h6"
                    style={{ color: "#d92727", fontWeight: "bold" }}
                  >
                    TOGETHER
                  </Typography>
                </div>
              </HashLink>
              <HashLink
                to="/about"
                style={{ textDecoration: "none", color: "lightgray" }}
              >
                <Typography variant="h6">About Us</Typography>
              </HashLink>
              <a
                href="https://github.com/axandrew/hackRU2022"
                style={{ textDecoration: "none", color: "lightgray" }}
              >
                <Typography variant="h6">GitHub</Typography>
              </a>
            </div>

            <div>
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar src="/static/images/avatar/2.jpg" />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <MenuItem
                  key={"profile"}
                  component={HashLink}
                  to="/profile"
                  onClick={handleCloseUserMenu}
                >
                  <Typography textAlign="center">Profile</Typography>
                </MenuItem>
                <MenuItem
                  key={"settings"}
                  component={HashLink}
                  to="/settings"
                  onClick={handleCloseUserMenu}
                >
                  <Typography textAlign="center">Settings</Typography>
                </MenuItem>
                <MenuItem key={"logout"} onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">Logout</Typography>
                </MenuItem>
              </Menu>
            </div>
          </div>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default NavBar;
